export default __webpack_public_path__ + "static/media/PowerGrotesk-UltraLightItalic.cf9044e3.otf";